export default __webpack_public_path__ + "static/media/asana.93366630.svg";